var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6974 0.743904C12.3205 0.460361 11.8198 0.410446 11.3912 0.6108L1.39435 5.27382C0.941089 5.47865 0.663817 5.90829 0.647605 6.40211C0.630757 6.90475 1.04932 7.47476 1.51099 7.66879L5.09514 9.17419C5.46273 9.32847 5.88801 9.20974 6.12247 8.88659L9.28709 4.53564C9.44538 4.31007 9.75765 4.26178 9.97669 4.42898C10.1947 4.58964 10.2423 4.89731 10.084 5.12287L6.91299 9.47549C6.67778 9.79808 6.69307 10.2414 6.95024 10.5475L9.46141 13.544C9.75636 13.9006 10.1941 14.0608 10.6365 13.9923C10.6886 13.9843 10.7471 13.9752 10.7982 13.9606C11.2955 13.8167 11.6452 13.4074 11.7189 12.8932L13.2051 1.95902C13.2729 1.49275 13.0743 1.02745 12.6974 0.743904Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.5f03e85d17329b40896c03cb60913298.svg";
export { ForwardRef as ReactComponent };